<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-14">
<div class="img_container">
<img alt="image" src="images/Img_14_001.jpg"/>
<p class="caption">Regional Map Key</p>
</div>
</a><a id="VPS-15">
<div class="img_container">
<img alt="image" src="images/Img_15_001.jpg"/>
<p class="caption">Regional Map 1. The Jazīra.</p>
</div>
</a><a id="VPS-16">
<div class="img_container">
<img alt="image" src="images/Img_16_001.jpg"/>
<p class="caption">Regional Map 2. The Upper Euphrates.</p>
</div>
</a><a id="VPS-17">
<div class="img_container">
<img alt="image" src="images/Img_17_001.jpg"/>
<p class="caption">Regional Map 3. The Middle Euphrates.</p>
</div>
</a><a id="VPS-18">
<div class="img_container">
<img alt="image" src="images/Img_18_001.jpg"/>
<p class="caption">Regional Map 4. Cilicia and Western Syria.</p>
</div>
</a><a id="VPS-19">
<div class="img_container">
<img alt="image" src="images/Img_20_001.jpg"/>
<p class="caption">Regional Map 5. Western Syria and Northern Lebanon.</p>
</div>
</a><a id="VPS-20">
<div class="img_container">
<img alt="image" src="images/Img_21_001.jpg"/>
<p class="caption">Regional Map 6. Lebanon and Northern Palestine.</p>
</div>
</a><a id="VPS-21">
<div class="img_container">
<img alt="image" src="images/Img_22_001.jpg"/>
<p class="caption">Regional Map 7. Southern Palestine.</p>
</div>
</a><a id="VPS-22">
<div class="img_container">
<img alt="image" src="images/Img_23_001.jpg"/>
<p class="caption">Regional Map 8. Sinai.</p>
</div>
</a><a id="VPS-23">
<div class="img_container">
<img alt="image" src="images/Img_24_001.jpg"/>
<p class="caption">Regional Map 9. Egypt.</p>
</div>
</a><a id="VPS-24">
<div class="img_container">
<img alt="image" src="images/Img_25_001.jpg"/>
<p class="caption">Regional Map 10. Cyprus.</p>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Map.vue?0a38cd6a